<script setup lang="ts">

import { useConfigStore } from '@/stores/manageConfig';
import { QNotify } from '@/utils/QNotify';
import { getOrderByNo, updateOrderProof } from '@/api/finance/trading/pay/order';
import { copyToClipboard } from 'quasar';
import UsdtDesc from '@/views/USDT/src/UsdtDesc.vue';
import UploadProof from '@/views/PaymentRecords/src/components/UploadProof.vue';

defineOptions({
  name: 'UsdtPay'
});

interface settlementVO {
  productName: string;
  totalPrice: number;
}

const props = defineProps({
  payNo: {
    type: String,
    required: true
  }
});

const { t } = useI18n();
const { back, replace } = useRouter();

const { payNo } = props;

const { getUsdtPayAddr } = toRefs(useConfigStore());

const payAddress = computed(() => {
  return getUsdtPayAddr.value || '';
});

const isDark = import.meta.env.VITE_APP_DARK_MODE === 'true';

onMounted(async () => {
  if (!payNo) {
    // QNotify.error(t('common.error'));
    replace({ name: 'Home' });
    return;
  }
  const payOrder = await getOrderByNo(payNo);
  // console.log('payOrder', payOrder);

  if (!payOrder) {
    replace({ name: 'Home' });
    return;
  }
});

const toOrder = () => {
  replace({ name: 'Order' });
};

const updateProofImg = async (imgUrl: string, proofDesc: string) => {
  await updateOrderProof({
    no: payNo,
    proofImg: imgUrl,
    proofDesc
  });
  QNotify.success(t('common.success'));
};

const uploadSuccess = () => {
  // console.log('uploadSuccess');
  toOrder();
};

/** 复制 **/
const copy = async (text: string) => {
  // const { copy, copied, isSupported } = useClipboard({ source: text })
  // if (!isSupported.value) {
  //   QNotify.error(t('common.copyError'))
  //   return
  // }
  // await copy()
  // if (unref(copied)) {
  //   QNotify.success(t('common.copySuccess'))
  // }
  copyToClipboard(text)
    .then(() => {
      // 成功!
      QNotify.success(t('common.copySuccess'));
    })
    .catch(() => {
      // 失败
      QNotify.error(t('common.copyError'));
    });
};

</script>

<template>
  <q-layout view="lHr LpR lFr" :class="isDark ? 'whiteText' : 'darkText'">
    <q-page-container>
      <q-header class="bg-header column items-center">
        <q-bar class="bg-header q-pa-md q-py-lg text-weight-bold" :class="isDark ? 'text-grey-1' : 'text-grey-9'">
          <q-btn dense rounded flat icon="svg:back" @click="toOrder"
                 class="absolute-left q-pl-md" :ripple="false"
          />
          <q-space />
          <div v-text="t('router.usdt')" />
          <q-space />
        </q-bar>
      </q-header>
      <q-page class="bg-common q-pa-md column no-wrap">

        <UsdtDesc />
        <!--付款地址-->
        <div class="q-py-xl">
          <div class="q-pl-md row items-center">
            <div class="q-pr-sm">
              <q-icon color="primary" name="assured_workload" size="sm" />
            </div>
            <div class="text-primary text-subtitle1 text-weight-bold">{{ t('usdt.address') }}</div>
          </div>
          <q-input
            v-model="payAddress"
            outlined rounded dense readonly :dark="isDark"
            class="text-no-wrap ellipsis"
          >
            <template v-slot:append>
              <q-btn
                rounded no-caps unelevated dense
                class="q-py-none q-px-md text-caption"
                color="primary"
                :label="t('common.copy')"
                @click="copy(payAddress)"
              />
            </template>
          </q-input>
        </div>

        <UploadProof
          :success-func="updateProofImg"
          @success="uploadSuccess" />
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<style lang="scss" scoped>

.payment-box {
  display: inline-block;
  border-top: 1px solid $primary;
  //border-left: 1px solid $primary;
  //border-right: 1px solid $primary;
}

</style>